import React, {useState} from "react";
import parse from "html-react-parser";
import {ChevronDown} from "./icons";
import Fade from "react-reveal/Fade";

const Faqs = ({title, subtitle, items}) => {
  const [active, setActive] = useState(null)
  const first = items.slice().splice(0, Math.ceil(items.length / 2))
  const second = items.slice().splice(Math.ceil(items.length / 2), items.length)

  const toggle = (i) => {
    if (i === active) {
      setActive(null)
      return
    }

    setActive(i)
  }

  return (
    <section className='faqs' id="faqs">
      <Fade bottom distance='30px'>
        <div className="faqs__inner">
          <div className='faqs__title'>
            {subtitle && <p>{subtitle}</p>}
            {title && <h3>{parse(title)}</h3>}
          </div>

          <div className='faqs__wrapper'>
            <div className='faqs__items'>
              {
                first?.length > 0 && first.map((el, i) => (
                  <div key={i} onClick={() => toggle(i)} className={`faqs__item ${active === i ? 'active' : ''}`}>
                    <div className='faqs__item-title'>
                      <h4>{el.title}</h4>
                      <ChevronDown/>
                    </div>
                    <div className='faqs__item-content'>
                      {parse(el.content)}
                    </div>
                  </div>
                ))
              }
            </div>

            <div className='faqs__items'>
              {
                second?.length > 0 && second.map((el, i) => (
                  <div key={i + first.length} onClick={() => toggle(i + first.length)}
                       className={`faqs__item ${active === i + first.length ? 'active' : ''}`}>
                    <div className='faqs__item-title'>
                      <h4>{el.title}</h4>
                      <ChevronDown/>
                    </div>
                    <div className='faqs__item-content'>
                      {parse(el.content)}
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </Fade>
    </section>
  )
}

export default Faqs